<template>
<div class="load-content">
     <div class="loadEffect _loadEffect">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
</div>
   
</template>

<script>
    export default {
        data() {
            return {};
        }
    };
</script>

<style lang="scss" scoped>
.load-content{
    width: 100%;
    height: 100vh;
    position: fixed;
    display: flex;
    justify-content: center;
    top: 0;
    z-index: 999999;
    background-color: white;
    opacity: 0.6;
}
    .loadEffect {
        width: 100px;
        height: 100px;
        position: relative;
        margin-top: 15rem;
        span {
            display: inline-block;
            width: 15px;
            height: 15px;
            border-radius: 50%;
            background: #dc6350;
            position: absolute;
            animation: load 1.04s ease infinite;
            &:nth-child(1) {
                 left: 0;
                 top: 50%;
                 margin-top: -10px;
                 animation-delay: 0.13s;
             }
            &:nth-child(2) {
                 left: 14px;
                 top: 14px;
                 animation-delay: 0.26s;
             }
            &:nth-child(3) {
                 left: 50%;
                 top: 0;
                 margin-left: -10px;
                 animation-delay: 0.39s;
             }
            &:nth-child(4) {
                 top: 14px;
                 right: 14px;
                 animation-delay: 0.52s;
             }
            &:nth-child(5){
                 right: 0;
                 top: 50%;
                 margin-top: -10px;
                 animation-delay: 0.65s;
             }
            &:nth-child(6) {
                 right: 14px;
                 bottom:14px;
                 animation-delay: 0.78s;
             }
            &:nth-child(7) {
                 bottom: 0;
                 left: 50%;
                 margin-left: -10px;
                 animation-delay: 0.91s;
             }
            &:nth-child(8) {
                 bottom: 14px;
                 left: 14px;
                 animation-delay: 1.04s;
             }
        }
        @keyframes load{
            0% {
                transform: scale(1);
                opacity: 1;
            }
            100% {
                transform: scale(.4);
                opacity: 0.5;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/loading.vue